import { render, staticRenderFns } from "./childRender.vue?vue&type=template&id=7330e5d2&scoped=true"
import script from "./childRender.vue?vue&type=script&lang=js"
export * from "./childRender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7330e5d2",
  null
  
)

export default component.exports